import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,_vm._g(_vm._b({attrs:{"right":!Object.keys(_vm.$attrs).find(function (x) { return ['top', 'bottom', 'left'].includes(x); }),"content-class":("text white--text custom-tooltip " + _vm.orientation_class + " " + (_vm.$attrs.hasOwnProperty('small') ? 'small': '')),"data-test-id":"tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._t("activator")],2)]}}],null,true)},'v-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }